import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

// Componets
import Navbar from "../componets/Navbar";
import BreadCrumb from "../componets/BreadCrumb";
import { getBasket } from "../../features/web/ShopingCart";
// react router
import { Link, useNavigate } from "react-router-dom";
import Footer from "../componets/Footer";
import CopyWrite from "../componets/CopyWrite";
import { useTranslation } from "react-i18next";
import { CheckBadgeIcon, MapPinIcon } from "@heroicons/react/24/outline";
import varyBackground from "../../../src/web/assets/images/varybackground.jpg";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAddresses } from "../../features/Global/Address";
import { PlusCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import NewAddressModal from "../componets/shop/Checkout";
import { TextareaAutosize } from "@mui/material";
import { getContact } from "../../features/Global/ContactUs";
import { getCities } from "../../features/Global/Cities";
import { Player } from "@lottiefiles/react-lottie-player";
import loaderAnim from "../assets/icons/SubmitOrder.json";
import SnackBar from "../componets/Snackbar/SnackBarCheckout";
import Cookies from "js-cookie";
import FIBPaymentModal from "../componets/FIB/FIBPaymentModal";
const Checkout = () => {
  const { t } = useTranslation();
  const l = localStorage.getItem("i18nextLng");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.ShopingCart.data);
  const total = useSelector((state) => state.ShopingCart.total);
  const address = useSelector((state) => state.Address.data);
  const contact = useSelector((state) => state.Contact.data);
  const cities = useSelector((state) => state.Cities.data);
  const customer = JSON?.parse(Cookies.get("Customer"));

  let [isOpen, setIsOpen] = useState(false);
  let [payment, setPayment] = useState(false);
  let [FIBModal, setFIBModal] = useState(false);
  let [FIBResponse, setFIBResponse] = useState("");

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }
  useEffect(() => {
    dispatch(getBasket());
    dispatch(getAddresses());
    dispatch(getContact());
    dispatch(getCities());
  }, []);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const handleSelectAddress = (e) => {
    // console.log(e);
    setSelectedAddress(e);
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const config = {
    headers: {
      Authorization: `Bearer ${Cookies.get("webAuth")}`,
    },
  };
  const onSubmit = (data) => {
    data.addressId = parseInt(data?.addressId);
    data.cashType = payment;
    //    console.log(data);

    // FIB Response
    // {
    //   "message": "Order Success, Thank You for choosing Vary Pharmacy.",
    //   "hasPaymentResponse": true,
    //   "hasPaymentErrors": false,
    //   "fibDetails": {
    //       "paymentId": "cad69178-64a2-4d6a-a780-9daeddd08781",
    //       "readableCode": "SWS9-JHPR-EVT7",
    //       "qrCode": "data:image/png;base64,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",
    //       "validUntil": "2023-09-02T07:50:00.287Z",
    //       "personalAppLink": "https://personal.stage.first-iraqi-bank.co/?link=https://personal.stage.first-iraqi-bank.co/onlinePayment?identifier%3DSWS9JHPREVT7&apn=com.firstiraqibank.personal.staging&ibi=se.core.Lawrencespring.staging",
    //       "businessAppLink": "https://business.stage.first-iraqi-bank.co/?link=https://business.stage.first-iraqi-bank.co/onlinePayment?identifier%3DSWS9JHPREVT7&apn=com.firstiraqibank.business.staging&ibi=se.core.Lawrencespring.business.staging",
    //       "corporateAppLink": "https://corporate.stage.first-iraqi-bank.co/?link=https://corporate.stage.first-iraqi-bank.co/onlinePayment?identifier%3DSWS9JHPREVT7&apn=com.firstiraqibank.corporate.staging&ibi=se.core.Lawrencespring.corporate.staging"
    //   }
    // }

    axios
      .post("/api/Orders/SubmitOrder", data, config)
      .then((r) => {
        console.log(r);
        if (r.status === 200) {
          if (payment === 0) {
            setSuccess(true);
            
            setTimeout(() => {
              navigate("/");
            }, 3000);
          } else if (payment === 1) {
            setFIBResponse(r.data)
            setFIBModal(true);
            // setSuccess(true);
          }
        }
      })
      .catch((e) => console.log(e.message));
    // }
  };
  const onSubmitNewAddress = (data) => {
    console.log(data);
    data.detailedAdderess = data.detailedAdderess || "";
    axios
      .post("api/OrderAddresses", data, config)
      .then((r) => {
        if (r.status === 200 || r.status === 204) {
          // setToast(true);
          dispatch(getAddresses());
          setIsOpen(false);
        }
      })
      .catch((e) => {
        console.log(e.response);
        console.log(e.response.data);
        // setMessage(e.response.data);
        // setError(true);
      });
  };

  return (
    <div>
      <Navbar />
      {/* <!-- ./breadcrumb --> */}

      {/* <!-- wrapper --> */}
      {/* <div className="container grid items-start grid-cols-12 gap-6 pt-4 pb-16">
        
        
        
      </div> */}
      <div className="container relative w-full mx-auto bg-white">
        {/* <BreadCrumb Name={"checkout"} Iconn={CheckBadgeIcon} /> */}
        <div className="grid min-h-screen grid-cols-10">
          <form
            className="px-4 py-6 col-span-full sm:py-12 lg:col-span-6 lg:py-24"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="w-full max-w-lg mx-auto">
              <h1
                className={`relative text-2xl font-medium text-gray-700 sm:text-3xl ${l}`}
              >
                {t("checkout")}
                <span className="block w-10 h-1 mt-2 bg-pink-600 sm:w-20"></span>
              </h1>
              <div className="flex">
                <span
                  className={`flex-1 w-10 h-1 mt-2 text-gray-600 sm:w-20 ${l}`}
                >
                  {t("pleaseChooseDelivaryAddress")}
                </span>
                <button
                  className={`${l}  my-2 hover:scale-x-110 hover:scale-y-105 duration-500  ${
                    l === "en-US" ? "float-right" : " float-left"
                  } group flex w-60 items-center justify-center rounded-lg bg-gradient-to-br from-pink-500 to-pink-500  py-2 text-center  text-white transition
                ${l}  `}
                  onClick={() => setIsOpen(true)}
                >
                  <PlusCircleIcon className={`inline w-4 mx-1`} />
                  {t("addAddress")}
                </button>{" "}
              </div>

              <span action="" className="flex flex-col mt-4 space-y-4">
                <div>
                  <div className="flex flex-col w-full pb-8 my-2 overflow-y-auto">
                    <select
                      // type="text"
                      placeholder={t("city")}
                      {...register("addressId", { required: false })}
                      className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                        errors.city &&
                        "focus:ring-rose-100 focus:border-rose-300"
                      } ${l}`}
                    >
                      {address.map((item, index) => (
                        // value={cityId}
                        <option
                          value={item?.id}
                          // onClick={() => handleSelectAddress(item?.id)}
                          onChange={() => setSelectedAddress(item?.id)}
                          className={`${l === "en-US" ? "" : "ku"}`}
                        >
                          {item?.addressTitle}
                          {/* {l === "en-US" && item?.englishCity}
                          {l === "ar" && item?.arabicCity}
                          {l === "ku" && item?.kurdishCity} */}
                        </option>
                      ))}
                    </select>
                  </div>
                  <label className="block" htmlFor="name">
                    <textarea
                      type="text"
                      className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                        errors.note &&
                        "focus:ring-rose-100 focus:border-rose-300"
                      } ${l}`}
                      placeholder={t("note")}
                      {...register("note", {
                        required: false,
                      })}
                    />
                  </label>
                </div>
                <div className="relative"></div>
              </span>
              <div className={`flex relative `}>
                <div className="flex gap-x-4">
                  <div className="relative flex items-center justify-center px-2 py-3 font-medium text-gray-700 w-36 md:w-40 rounded-xl bg-gray-50">
                    <input
                      className="hidden peer"
                      type="radio"
                      name="radio"
                      id="radio1"
                      onClick={() => setPayment(0)}
                      checked={payment === 0}
                    />
                    <label
                      className="absolute top-0 w-full h-full border cursor-pointer peer-checked:border-rose-400 peer-checked:bg-rose-200 rounded-xl"
                      htmlFor="radio1"
                    >
                      {" "}
                    </label>
                    <div
                      className={`peer-checked:border-transparent peer-checked:bg-rose-400 peer-checked:ring-2 absolute ${
                        l === "en-US" ? "left-4" : "right-4"
                      } h-5 w-5 rounded-full border-2 border-gray-300 bg-gray-200 ring-rose-400 ring-offset-2`}
                    ></div>
                    <span className={`pointer-events-none z-10 ${l}`}>
                      {t("cash")}
                    </span>
                  </div>
                  <div className="relative flex items-center justify-center px-4 py-3 font-medium text-gray-700 w-36 md:w-40 rounded-xl bg-gray-50">
                    <input
                      className="hidden peer"
                      type="radio"
                      name="radio"
                      id="radio3"
                      onClick={() => setPayment(1)}
                      checked={payment === 1}
                    />
                    <label
                      className="absolute top-0 w-full h-full border cursor-pointer peer-checked:border-teal-600 peer-checked:bg-teal-200 rounded-xl"
                      htmlFor="radio3"
                    >
                      {" "}
                    </label>
                    <div
                      className={`peer-checked:border-transparent peer-checked:bg-teal-400 peer-checked:ring-2 absolute ${
                        l === "en-US" ? "left-4" : "right-4"
                      }  h-5 w-5 rounded-full border-2 border-gray-300 bg-gray-200 ring-teal-400 ring-offset-2`}
                    ></div>
                    <span className={`pointer-events-none z-10 ${l}`}>
                      {/* <img src="../../assets/images/fib.jpeg" alt="fin-logo" className="inline w-6 h-6 rounded-lg"/> */}
                      {t("FIB")}
                    </span>
                  </div>
                </div>
              </div>
              <br />
              {customer?.isPhoneConfirmed ? (
                <>
                  <button
                    // disabled={selectedAddress === null}
                    onClick={() => handleSubmit(onSubmit)}
                    type="submit"
                    className={` inline-flex w-full items-center mx-auto justify-center rounded bg-gradient-to-br from-pink-600 to-pink-500 py-2.5 px-4 text-base font-semibold tracking-wide text-white text-opacity-80 outline-none ring-offset-2 transition hover:text-opacity-100 focus:ring-2 focus:ring-pink-500 sm:text-lg hover:scale-x-110 hover:scale-y-105 duration-500 ${
                      l === "en-US" ? "" : "float-right right-3"
                    } ${l}`}
                  >
                    {t("placeOrder")}
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/userProfile"
                    className={`group inline-flex w-full items-center justify-center rounded-md bg-blue-500 px-6 py-4 text-lg font-semibold text-white transition-all duration-200 ease-in-out focus:shadow hover:bg-blue-600 ${l}`}
                  >
                    {t("accountVerification")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6 ml-4 transition-all group-hover:ml-8"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </Link>
                </>
              )}
            </div>
          </form>
          <div className="relative flex flex-col py-6 pl-8 pr-4 col-span-full sm:py-12 lg:col-span-4 lg:py-24">
            <h2 className={`sr-only ${l}`}>{t("orderSummary")}</h2>
            <div>
              <img
                src={varyBackground}
                alt="vary"
                className="absolute inset-0 object-cover w-full h-full"
              />
              <div className="absolute inset-0 w-full h-full bg-gradient-to-t from-pink-800 to-pink-400 opacity-95"></div>
            </div>
            <div className="relative">
              <ul className="space-y-5">
                {data?.map((product) => (
                  <li className="flex justify-between">
                    <div className="inline-flex">
                      {/* <img src={product.imageUrl} alt="" className="max-h-16" /> */}
                      <div className="ml-3">
                        <p
                          className={`text-base font-semibold text-white ${l}`}
                        >
                          {l === "en-US" && product.procudtName.english}
                          {l === "ar" && product.procudtName.arabic}
                          {l === "ku" && product.procudtName.kurdish}{" "}
                        </p>
                        {/* <p className="text-sm font-medium text-white text-opacity-80">
                          Pdf, doc Kindle
                        </p> */}
                      </div>
                    </div>
                    <p className={`text-sm font-semibold text-white ${l}`}>
                      {" "}
                      {Intl.NumberFormat()?.format(product.price * product.qty)}
                      {t("iqd")}
                    </p>
                  </li>
                ))}
              </ul>
              <div className="my-5 h-0.5 w-full bg-white bg-opacity-30"></div>
              <div className="space-y-2">
                <p className="flex justify-between text-lg font-bold text-white">
                  <span className={`${l}`}>{t("totalPrice")}:</span>
                  <span className={`${l}`}>
                    {Intl.NumberFormat().format(total)} {t("iqd")}
                  </span>
                </p>
              </div>
            </div>
            <div className="relative mt-10 text-white">
              <h3 className={`mb-5 text-lg font-bold ${l}`}>{t("support")}</h3>
              <p className="text-sm font-semibold">
                {contact[0]?.primaryPhoneNumber}{" "}
              </p>
              <p className="text-sm font-semibold">
                {contact[0]?.secondaryPhoneNumber}{" "}
              </p>
              <p className="mt-1 text-sm font-semibold">
                {contact[0]?.emailAddress} <span className="font-light"></span>
              </p>
            </div>
            <div className="relative flex mt-10">
              <p className="flex flex-col">
                <span className={`text-sm font-bold text-white ${l}`}>
                  {t("varyPharmacy")}
                </span>
                {/* <span className={`text-xs font-medium text-white ${l}`}>
                  {t("loginMot")}
                </span> */}
              </p>
            </div>
            <div className="relative flex mt-10">
              <p className="flex flex-col">
                <span className={`text-sm font-bold text-white ${l}`}>
                  {t("address")}:
                </span>
                <span className={`text-xs font-medium text-white ${l}`}>
                  {l === "en-US" && contact[0]?.englishAddress}
                  {l === "ar" && contact[0]?.arabicAddress}
                  {l === "ku" && contact[0]?.kurdishAddress}
                </span>
              </p>
            </div>
          </div>
        </div>
        {success && <SnackBar />}
        {isOpen && (
          <>
            <div className="fixed inset-0 flex items-center justify-center">
              <button
                type="button"
                onClick={openModal}
                className="px-4 py-2 text-sm font-medium text-white bg-black rounded-md bg-opacity-20 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
              >
                Open dialog
              </button>
            </div>

            <Transition appear show={isOpen} as={Fragment}>
              <Dialog as="div" className="relative z-10" onClose={closeModal}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                  <div className="flex items-center justify-center min-h-full p-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="w-full max-w-lg mt-16 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                        <div className="py-10 text-center text-white bg-gradient-to-br from-pink-600 to-pink-500">
                          <p className={`${l} text-2xl font-semibold`}>
                            <MapPinIcon className="inline w-8 mx-2 " />{" "}
                            {t("addAddress")}
                          </p>
                        </div>
                        <form
                          className="px-8 py-10 space-y-4"
                          onSubmit={handleSubmit(onSubmitNewAddress)}
                        >
                          <label className="block" htmlFor="name">
                            <input
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.addressTitle &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("addressTitle")}
                              {...register("addressTitle", { required: true })}
                            />
                          </label>
                          <label className="block" htmlFor="name">
                            <select
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.city &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("city")}
                              {...register("city", { required: true })}
                            >
                              {cities?.map((item) => (
                                <option
                                  value={item?.id}
                                  className={`${l === "en-US" ? "" : "ku"}`}
                                >
                                  {l === "en-US" && item?.englishCity}
                                  {l === "ar" && item?.arabicCity}
                                  {l === "ku" && item?.kurdishCity}
                                </option>
                              ))}
                            </select>
                          </label>
                          <label className="block" htmlFor="name">
                            <input
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.streetName &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("streetName")}
                              {...register("streetName")}
                            />
                          </label>

                          <label className="block" htmlFor="name">
                            <input
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.buildingName &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("buildingName")}
                              {...register("buildingName")}
                            />
                          </label>
                          <label className="block" htmlFor="name">
                            <input
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.buildingFloor &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("buildingFloor")}
                              {...register("buildingFloor")}
                            />
                          </label>
                          <label className="block" htmlFor="name">
                            <input
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.appartmentNumber &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("appartmentNumber")}
                              {...register("appartmentNumber", {})}
                            />
                          </label>
                          <label className="block" htmlFor="name">
                            <textarea
                              type="text"
                              className={`w-full px-3 py-3 placeholder-gray-300 border border-gray-300 rounded-xl focus:outline-none focus:ring focus:ring-pink-100 focus:border-pink-600 ${
                                errors.detailedAdderess &&
                                "focus:ring-rose-100 focus:border-rose-300"
                              } ${l}`}
                              placeholder={t("detailedAdderess")}
                              {...register("detailedAdderess", {})}
                            />
                          </label>
                          <hr className="w-4/5 mx-auto text-gray-400" />
                          <button
                            type="submit"
                            className={`my-4 rounded-md bg-gradient-to-br from-pink-600 to-pink-500 px-10 py-2 font-semibold text-white ${
                              l === "en-US" ? "" : " justify-end items-end"
                            } ${l}`}
                          >
                            <PlusCircleIcon
                              className={`inline w-6 mx-1 ${l}`}
                            />{" "}
                            {t("add")}
                          </button>
                        </form>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </>
        )}
      </div>

      <FIBPaymentModal
        show={FIBModal}
        setShow={setFIBModal}
        FIBResponse={FIBResponse}
      />
      <Footer />
      <CopyWrite />
    </div>
  );
};

export default Checkout;
